import { Component, Input, OnInit } from '@angular/core';
import { RolesEnum } from 'src/app/models/users/roles/enums/roles';

export interface LinkData {
  route: string;
  title: string;
  actions?: RolesEnum;
}


@Component({
  selector: 'app-tab-nav-route',
  templateUrl: './tab-nav-route.component.html'
})
export class TabNavRouteComponent implements OnInit {
  @Input() links: LinkData[] = [];
  @Input() backgroundColor: any = '';

  constructor() { }

  ngOnInit() {
    // console.log(this.links)
  }

}
